var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.52 29.94C35.28 31.2 34.26 32.16 33 32.34C31.02 32.64 27.72 33 24 33C20.34 33 17.04 32.64 15 32.34C13.74 32.16 12.72 31.2 12.48 29.94C12.24 28.56 12 26.52 12 24C12 21.48 12.24 19.44 12.48 18.06C12.72 16.8 13.74 15.84 15 15.66C16.98 15.36 20.28 15 24 15C27.72 15 30.96 15.36 33 15.66C34.26 15.84 35.28 16.8 35.52 18.06C35.76 19.44 36.06 21.48 36.06 24C36 26.52 35.76 28.56 35.52 29.94Z",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6016 28.2V19.8L28.8016 24L21.6016 28.2Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIc);
export default __webpack_public_path__ + "static/media/youtube_ic.08dc989f4f076f09535e9288a525fc4c.svg";
export { ForwardRef as ReactComponent };